import React from 'react';
import Skeleton from 'ati-ui-react/components/Skeleton';
import * as styles from './AppLoadingPage.scss';
import BreadcrumbsRowLoading from '../BreadcrumbsRowLoading';
import RatingFirmsLoading from '../RatingFirmsLoading';
import { rowCountDefault } from '../../constants/skeletonDefaults';
import DescriptionLoading from '../DescriptionLoading';

const AppLoadingPage = () => (
  <div className={styles.layout}>
    <div className={styles.content}>
      <BreadcrumbsRowLoading />
      <div className={styles.rating}>
        <DescriptionLoading />
        <div className={styles.fakeTabContainer}>
          <Skeleton className={styles.fakeTab} />
        </div>
        <div className={styles.fakeFilter}>
          <Skeleton className={styles.fakeButtons1} />
          <Skeleton className={styles.fakeButtons2} />
        </div>
        <RatingFirmsLoading rowsCount={rowCountDefault} />
      </div>
    </div>
  </div>
);

export default AppLoadingPage;
